import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { ItemStatsDto } from "../../../shared/dtos/item/ItemStatsDto";

interface ItemWidgetProps {
  data: ItemStatsDto;
}

const ItemWidget: React.FC<ItemWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("ITEM");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Items: {data.totalItems}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: "warning.main",
                mb: 0.5,
              }}
            >
              <WarningAmberIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Low Stock
              </Typography>
            </Box>
            <Typography variant="h4">{data.itemsBelowThreshold}</Typography>
          </Box>
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: "error.main",
                mb: 0.5,
              }}
            >
              <ErrorOutlineIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Out of Stock
              </Typography>
            </Box>
            <Typography variant="h4">{data.itemsOutOfStock}</Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};
export default ItemWidget;
